module Meevo.Components.Controls.SmartMover {
    import GiftCardType = Model.GiftCardType;


    export class GiftCardTypesCollection extends SmartMoverApiCollection<GiftCardType> implements IApiCollection<GiftCardType> {

        get url() {
            return 'Giftcardtype';
        }
    }
}
